import { getResourceSlugFromType } from "~/modules/link-parser";
import { featuredImage } from "~/modules/images";
import { createComponent, FelaComponent } from "react-fela";
import { combineRules } from "fela";
import { textStyles } from "~/styleguide/typography";
import resourceData from "~/data/resource-shared-data.json";
import FixedHeightExcerpt from "~/components/shared/fixed-height-excerpt";
import get from "lodash.get";

import WordpressLink from "~/components/global/links";
import Visual from "~/components/shared/visual";
import readTime from "~/modules/read-time";

export default function SummaryGrid({ resource, type, collectionLength }) {
    const image = featuredImage(resource);
    const typeURL = getResourceSlugFromType(resource.type || type);
    const excerpt = get(resource, "excerpt.rendered");
    const gridResourcePlaceholder = resourceData.data.acf.placeholder_image;
    const eyebrowText = readTime(resource);

    let ratio = 3 / 4;
    let rightMargin = 55;
    let bottomMargin = 55;

    if (type == "infographics") {
        ratio = 3 / 5;
        rightMargin = 125;
        bottomMargin = 60;
    }

    return (
        <PostGrid
            rightMargin={rightMargin}
            bottomMargin={bottomMargin}
            collectionLength={collectionLength}
        >
            {/* Image */}

            <WordpressLink url={`/${typeURL}`} slug={resource.slug}>
                <Visual
                    image={image ? image : gridResourcePlaceholder}
                    aspect={ratio}
                    background="cover"
                    extend={gridResourceImage}
                />
            </WordpressLink>

            {/* Read time */}
            <FelaComponent as="p" style={gridReadTime}>
                {eyebrowText}
            </FelaComponent>

            {/* Title */}
            <WordpressLink
                url={`/${typeURL}`}
                slug={resource.slug}
                label={resource.title.rendered}
                extend={combinedTypeRules}
            />

            {/* Excerpt */}
            {excerpt && (
                <FixedHeightExcerpt
                    extend={gridResourceExcerpt}
                    text={excerpt}
                    lineHeight={1.5}
                ></FixedHeightExcerpt>
            )}
        </PostGrid>
    );
}

//100% / 4 - horizontal-border - horizontal-padding - left-margin * (4 - 1) / 4

const PostGrid = createComponent(
    ({ rightMargin, bottomMargin, collectionLength }) => ({
        overflow: "hidden",
        transition: "flex-basis 250ms",
        minWidthTabletLandscape: {
            grid: {
                cols: "3",
                margins: rightMargin,
                bottomMargin: bottomMargin,
                length: collectionLength
            }
        },
        maxWidthTabletLandscape: {
            grid: {
                cols: "2",
                margins: rightMargin * 0.66,
                bottomMargin: bottomMargin * 0.66
            }
        },
        maxWidthMobile: {
            width: "100%",
            marginRight: 0
        }
    })
);

const gridResourceImage = {
    width: "100%",
    border: "1px solid grey",
    borderRadius: 6,
    overflow: "hidden",
    maxWidthTablet: {
        "& .vv-visual": {
            borderRadius: 5
        }
    }
};

const gridReadTime = {
    margin: "25px 0px 15px 0px"
};

const gridResourceTitle = {
    fontSize: 24,
    lineHeight: "30px"
};

const gridResourceExcerpt = {
    marginTop: 15
};

const combinedTypeRules = combineRules(
    textStyles.resourceHeading,
    gridResourceTitle
);
